import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      // Navigation
      nav: {
        home: "Inicio",
        statistics: "Estadísticas",
        favorites: "Favoritos",
        dashboard: "Dashboard",
        profile: "Perfil",
        admin: "Admin",
        manageStatistics: "Gestionar Estadísticas",
        login: "Iniciar Sesión",
        logout: "Cerrar Sesión",
        search: "Buscar",
        trending: "Trending",
        curioseme: "Curioseme",
        authentemia: "Authentemia",
        news: "Noticias"
      },

      // Common UI
      common: {
        loading: "Cargando...",
        error: "Error",
        success: "Éxito",
        cancel: "Cancelar",
        save: "Guardar",
        edit: "Editar",
        delete: "Eliminar",
        back: "Volver",
        next: "Siguiente",
        previous: "Anterior",
        close: "Cerrar",
        open: "Abrir",
        yes: "Sí",
        no: "No",
        retry: "Reintentar",
        tryAgain: "Intentar de nuevo",
        viewMore: "Ver más",
        readMore: "Leer más",
        explore: "Explorar",
        discover: "Descubrir",
        learn: "Aprender",
        contact: "Contacto",
        about: "Acerca de",
        settings: "Configuración",
        help: "Ayuda",
        support: "Soporte",
        recent: "Reciente",
        changeImage: "Cambiar Imagen",
        noImageSelected: "No hay imagen seleccionada",
        addImage: "Agregar Imagen",
        
        // Profile messages
        passwordChanged: "Contraseña cambiada",
        passwordUpdated: "Tu contraseña ha sido actualizada exitosamente.",
        profileUpdated: "Perfil actualizado",
        profileSaved: "Tu información personal ha sido guardada exitosamente.",
        roleUpdated: "Rol actualizado",
        accountTypeChanged: "El tipo de cuenta ha sido cambiado exitosamente.",
        accountDeleted: "Cuenta eliminada",
        accountDataDeleted: "Tu cuenta y todos los datos han sido eliminados permanentemente.",
        photoUpdated: "Foto actualizada",
        profilePhotoChanged: "Tu foto de perfil ha sido cambiada exitosamente.",
        fileTooLarge: "Archivo muy grande",
        fileSizeLimit: "Por favor selecciona una imagen menor a 5MB.",
        invalidFileType: "Tipo de archivo inválido",
        fileTypeLimit: "Por favor selecciona solo archivos JPG o PNG.",
        errorReadingFile: "Error al leer el archivo",
        errorUpdatingProfile: "Error al actualizar el perfil",
        errorChangingRole: "Error al cambiar el rol",
        errorDeletingAccount: "Error al eliminar la cuenta",
        errorUploadingImage: "Error al subir la imagen",
        
        // Form validation messages
        firstNameRequired: "El nombre es requerido",
        lastNameRequired: "El apellido es requerido",
        invalidEmail: "Dirección de correo electrónico inválida"
      },

      // Authentication
      auth: {
        login: "Iniciar Sesión",
        register: "Registrarse",
        logout: "Cerrar Sesión",
        signIn: "Iniciar Sesión",
        signUp: "Registrarse",
        signOut: "Cerrar Sesión",
        email: "Email",
        password: "Contraseña",
        confirmPassword: "Confirmar Contraseña",
        forgotPassword: "¿Olvidaste tu contraseña?",
        resetPassword: "Restablecer Contraseña",
        rememberMe: "Recordarme",
        createAccount: "Crear Cuenta",
        alreadyHaveAccount: "¿Ya tienes una cuenta?",
        dontHaveAccount: "¿No tienes una cuenta?",
        accountDeleted: "Cuenta Eliminada",
        accountRestricted: "Acceso Restringido",
        authenticationFailed: "Autenticación Fallida",
        unauthorized: "No Autorizado"
      },

      // Dashboard & Home
      dashboard: {
        welcomeBack: "¡Bienvenido de vuelta",
        accountStatus: "Estado de la Cuenta",
        emailStatus: "Estado del Email",
        subscription: "Suscripción",
        memberSince: "Miembro desde",
        active: "Activo",
        inactive: "Inactivo",
        verified: "Verificado",
        pending: "Pendiente",
        free: "Gratis",
        quickActions: "Acciones Rápidas",
        recentActivity: "Actividad Reciente",
        statistics: "Estadísticas",
        analytics: "Analíticas",
        reports: "Reportes",
        settings: "Configuración",
        accountOverview: "Resumen de la Cuenta",
        upgradeToPremium: "Actualizar a Premium"
      },

      // Profile
      profile: {
        title: "Configuración de Perfil",
        subtitle: "Administra tu información personal y configuración de cuenta",
        tabs: {
          profile: "Perfil",
          account: "Cuenta"
        },
        personalInfo: "Información Personal",
        profileImage: {
          changePhoto: "Haz clic en el ícono de la cámara para cambiar tu foto de perfil.",
          fileInfo: "Solo archivos JPG y PNG, máximo 5MB",
          uploading: "Subiendo..."
        },
        form: {
          firstName: "Nombre",
          lastName: "Apellido",
          email: "Correo Electrónico",
          bio: "Biografía",
          bioPlaceholder: "Cuéntanos sobre ti...",
          location: "Ubicación",
          locationPlaceholder: "Ciudad, País",
          website: "Sitio Web",
          websitePlaceholder: "https://ejemplo.com",
          phone: "Teléfono",
          phonePlaceholder: "+1 (555) 123-4567",
          saveChanges: "Guardar Cambios",
          saving: "Guardando..."
        },
        accountManagement: {
          title: "Gestión de Tipo de Cuenta",
          changeAccountType: "Cambiar Tipo de Cuenta",
          selectAccountType: "Seleccionar tipo de cuenta",
          adminRequired: "Se requiere acceso de administrador para cambiar tipos de cuenta",
          roles: {
            guest: "Invitado",
            user: "Usuario",
            premium: "Premium",
            admin: "Administrador"
          }
        },
        dangerZone: {
          title: "Zona Peligrosa",
          deleteAccount: "Eliminar Cuenta",
          deleteAccountDescription: "Una vez eliminada, tu cuenta no se puede recuperar. Esta acción eliminará permanentemente todos tus datos.",
          deleteMyAccount: "Eliminar Mi Cuenta",
          confirmDelete: "¿Estás absolutamente seguro?",
          confirmDeleteDescription: "Esta acción no se puede deshacer. Esto eliminará permanentemente tu cuenta y todos los datos asociados con ella.",
          subscriptionWarning: "Si tienes una suscripción activa, se cancelará automáticamente al final del período de facturación actual. No se realizarán más cobros.",
          cancel: "Cancelar",
          yesDeleteAccount: "Sí, eliminar cuenta",
          deleting: "Eliminando..."
        }
      },

      // Favorites
      favorites: {
        myFavorites: "Mis Favoritos",
        loadingFavorites: "Cargando favoritos...",
        errorLoadingFavorites: "Error al cargar favoritos",
        noFavoritesYet: "No tienes favoritos aún",
        saveFavoritesDescription: "Guarda tus estadísticas favoritas haciendo clic en el corazón ❤️",
        exploreStatistics: "Explorar estadísticas",
        savedStatistics: "estadísticas guardadas",
        savedStatistic: "estadística guardada",
        returnToDashboard: "Volver al Dashboard"
      },

      // Statistics
      statistics: {
        title: "Estadísticas",
        trending: "Trending",
        latest: "Últimas",
        popular: "Populares",
        featured: "Destacadas",
        categories: "Categorías",
        category: "Categoría",
        politics: "Política",
        society: "Sociedad",
        economy: "Economía",
        culture: "Cultura",
        technology: "Tecnología",
        entertainment: "Entretenimiento",
        sports: "Deportes",
        science: "Ciencia",
        lifestyle: "Life Style",
        unclassified: "Inclasificables",
        viewStatistics: "Ver estadísticas",
        readMore: "Leer más",
        share: "Compartir",
        favorite: "Favorito",
        unfavorite: "Quitar de favoritos",
        loadingTrending: "🔄 Cargando artículos trending...",
        errorLoadingTrending: "Error cargando trending",
        noTrendingArticles: "No hay artículos trending",
        trendingDescription: "Los artículos más valorados aparecerán aquí",
        featuredDescription: "Marca un artículo como destacado para que aparezca aquí en formato grande",
        
        // Statistics List Page
        hero: {
          description: "Descubre insights fascinantes y datos reveladores que transforman la forma en que vemos el mundo."
        },
        search: {
          placeholder: "Buscar estadísticas...",
          button: "Buscar",
          allCategories: "Todas las categorías"
        },
        results: {
          showing: "Mostrando",
          of: "de",
          statistics: "estadísticas",
          noResults: "No se encontraron estadísticas",
          tryFilters: "Intenta ajustar los filtros de búsqueda.",
          noStatistics: "No hay estadísticas disponibles en este momento."
        },
        pagination: {
          previous: "Anterior",
          next: "Siguiente"
        },
        
        // Image and Content Attribution
        image: {
          designedBy: "Diseñado por",
          photoBy: "Foto de",
          updated: "Actualizado"
        }
      },

      // Landing Page
      landing: {
        hero: {
          title: "Descubre",
          subtitle: "lo no evidente",
          description: "Descubre datos que nunca supiste que necesitabas saber.",
          scrollDown: "Desplázate hacia abajo para explorar"
        },
        features: {
          title: "Cómo Funciona",
          description: "Descubre cómo Statemia transforma datos invisibles en insights reveladores que cambian la forma en que entendemos el mundo.",
          dataAnalysis: "Datos No Medibles",
          dataAnalysisDesc: "Convertimos comportamientos invisibles y patrones ocultos en métricas cuantificables. Desde hábitos cotidianos hasta tendencias sociales emergentes.",
          realTimeInsights: "Algoritmos Novedosos",
          realTimeInsightsDesc: "Nuestros algoritmos avanzados identifican correlaciones inesperadas y patrones que los métodos tradicionales no pueden detectar.",
          userExperience: "Revisión Humana",
          userExperienceDesc: "Cada estadística pasa por un proceso de validación por nuestros expertos en datos, asegurando precisión, contexto y relevancia en cada insight."
        },
        trending: {
          title: "Trending",
          description: "Las estadísticas más populares y relevantes del momento",
          viewAll: "Ver todas las estadísticas"
        },
        curioseme: {
          title: "Curioseme",
          description: "Datos curiosos y sorprendentes que te harán pensar diferente",
          exploreCurioseme: "Explorar Curioseme"
        },
        authentemia: {
          title: "Authentemia",
          description: "Contenido verificado y de alta calidad para análisis confiables",
          learnMore: "Aprender más sobre Authentemia"
        },
        news: {
          title: "Noticias",
          description: "Las últimas noticias y actualizaciones del mundo de los datos",
          readLatestNews: "Leer las últimas noticias"
        },
        demo: {
          title: "Demo Video",
          description: "Próximamente: Video demostración de Statemia"
        }
      },

      // Footer
      footer: {
        description: "Statemia revoluciona la forma en que analizas datos. Descubre datos que nunca supiste que necesitabas saber.",
        categories: "Categorías",
        legal: "Legal",
        aboutUs: "Acerca de nosotros",
        contact: "Contacto",
        legalNotice: "Aviso Legal",
        privacyPolicy: "Política de Privacidad",
        termsOfService: "Términos de Servicio",
        cookiePolicy: "Política de Cookies",
        copyright: "© 2025 Statemia. Todos los derechos reservados."
      },

      // Admin
      admin: {
        title: "Panel de Administración",
        users: "Usuarios",
        totalUsers: "Total de Usuarios",
        activeUsers: "Usuarios Activos",
        premiumUsers: "Usuarios Premium",
        adminUsers: "Usuarios Admin",
        maintenanceMode: "Modo de Mantenimiento",
        systemStatus: "Estado del Sistema",
        systemSettings: "Configuración del Sistema",
        userManagement: "Gestión de Usuarios",
        analytics: "Analíticas",
        logs: "Registros",
        maintenance: "Mantenimiento",
        status: "Estado",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
        online: "En Línea",
        offline: "Desconectado"
      },

      // Legal
      legal: {
      cookies: {
          essential: "Cookies Esenciales",
          analytics: "Cookies de Análisis",
          preferences: "Cookies de Preferencias",
          functionality: "Cookies de Funcionalidad",
          advertising: "Cookies de Publicidad"
        },
        
        // Cookie Banner
        message: "Utilizamos cookies para mejorar tu experiencia en nuestro sitio web. Al continuar navegando, aceptas nuestro uso de cookies.",
        learn_more: "Más información",
        accept: "Aceptar"
      },

      // GDPR Cookie Banner
      gdpr: {
        title: "Configuración de Cookies",
        subtitle: "Controla tu privacidad y experiencia",
        message: "Utilizamos cookies y tecnologías similares para mejorar tu experiencia en Statemia. Algunas cookies son esenciales para el funcionamiento del sitio, mientras que otras nos ayudan a personalizar contenido y analizar el tráfico. Puedes elegir qué tipos de cookies aceptar.",
        categories: {
          title: "Tipos de Cookies",
          essential: {
            title: "Cookies Esenciales",
            description: "Necesarias para el funcionamiento básico del sitio web. No se pueden deshabilitar.",
            type: "Obligatorias"
          },
          analytics: {
            title: "Cookies de Análisis",
            description: "Nos ayudan a entender cómo los usuarios interactúan con nuestro sitio web recopilando información de forma anónima (Google Analytics).",
            type: "Opcionales"
          },
          preferences: {
            title: "Cookies de Preferencias",
            description: "Recuerdan tus elecciones y configuraciones para personalizar tu experiencia.",
            type: "Opcionales"
          },
          functionality: {
            title: "Cookies de Funcionalidad",
            description: "Permiten funciones mejoradas como recordar tus favoritos y configuraciones de visualización.",
            type: "Opcionales"
          },
          advertising: {
            title: "Cookies de Publicidad",
            description: "Permiten mostrar anuncios relevantes a través de Google AdSense y medir su rendimiento. Sin este consentimiento no se personalizan anuncios.",
            type: "Opcionales"
          }
        },
        customize: "Personalizar",
        consent: "Consentimiento",
        details: "Detalles",
        consentTitle: "Esta página web usa cookies",
        consentMessage: "Las cookies de este sitio web se usan para personalizar el contenido y los anuncios, ofrecer funciones de redes sociales y analizar el tráfico. Además, compartimos información sobre el uso que haga del sitio web con nuestros partners de redes sociales, publicidad y análisis web, quienes pueden combinarla con otra información que les haya proporcionado o que hayan recopilado a partir del uso que haya hecho de sus servicios.",
        detailsMessage: "Puedes personalizar qué tipos de cookies aceptar. Las cookies esenciales son necesarias para el funcionamiento del sitio web.",
        acceptAll: "Permitir todas",
        rejectAll: "Denegar",
        back: "Volver",
        savePreferences: "Guardar Preferencias",
        cancel: "Cancelar",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
        learnMore: "Más información",
        privacyPolicy: "Política de Privacidad",
        lastUpdated: "Última actualización: " + new Date().toLocaleDateString()
      },
      disclaimer: "La información en esta plataforma se proporciona \"tal como está\". No realizamos representaciones",
      contact: {
        email: "alejandro@statemia.com",
        support: "Soporte Técnico"
      }
    },

    // Notifications & Messages
    notifications: {
      success: "Éxito",
      error: "Error",
      warning: "Advertencia",
      info: "Información",
      accountAccessRestricted: "Acceso a la cuenta restringido",
      accountDeleted: "Cuenta eliminada",
      authenticationFailed: "Autenticación fallida",
      unauthorized: "No autorizado",
      maintenanceModeUpdated: "Modo de mantenimiento actualizado exitosamente",
      failedToUpdateMaintenance: "Error al actualizar modo de mantenimiento"
    },

    // Social Media
    social: {
      twitter: "Twitter",
      github: "GitHub",
      linkedin: "LinkedIn",
      discord: "Discord",
      followUs: "Síguenos",
      shareOn: "Compartir en"
    },

    // Time & Dates
    time: {
      today: "Hoy",
      yesterday: "Ayer",
      thisWeek: "Esta semana",
      thisMonth: "Este mes",
      thisYear: "Este año",
      ago: "hace",
      minutes: "minutos",
      hours: "horas",
      days: "días",
      weeks: "semanas",
      months: "meses",
      years: "años"
    },

    // Numbers & Currency
    numbers: {
      thousand: "mil",
      million: "millón",
      billion: "mil millones",
      trillion: "billón"
    }
  },

  en: {
    translation: {
      // Navigation
      nav: {
        home: "Home",
        statistics: "Statistics",
        favorites: "Favorites",
        dashboard: "Dashboard",
        profile: "Profile",
        admin: "Admin",
        manageStatistics: "Manage Statistics",
        login: "Login",
        logout: "Logout",
        search: "Search",
        trending: "Trending",
        curioseme: "Curioseme",
        authentemia: "Authentemia",
        news: "News"
      },

      // Common UI
      common: {
        loading: "Loading...",
        error: "Error",
        success: "Success",
        cancel: "Cancel",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        back: "Back",
        next: "Next",
        previous: "Previous",
        close: "Close",
        open: "Open",
        yes: "Yes",
        no: "No",
        retry: "Retry",
        tryAgain: "Try Again",
        viewMore: "View More",
        readMore: "Read More",
        explore: "Explore",
        discover: "Discover",
        learn: "Learn",
        contact: "Contact",
        about: "About",
        settings: "Settings",
        help: "Help",
        support: "Support",
        recent: "Recent",
        changeImage: "Change Image",
        noImageSelected: "No image selected",
        addImage: "Add Image",
        
        // Profile messages
        passwordChanged: "Password changed",
        passwordUpdated: "Your password has been updated successfully.",
        profileUpdated: "Profile updated",
        profileSaved: "Your personal information has been saved successfully.",
        roleUpdated: "Role updated",
        accountTypeChanged: "The account type has been changed successfully.",
        accountDeleted: "Account deleted",
        accountDataDeleted: "Your account and all data have been permanently deleted.",
        photoUpdated: "Photo updated",
        profilePhotoChanged: "Your profile photo has been changed successfully.",
        fileTooLarge: "File too large",
        fileSizeLimit: "Please select an image smaller than 5MB.",
        invalidFileType: "Invalid file type",
        fileTypeLimit: "Please select only JPG or PNG files.",
        errorReadingFile: "Error reading file",
        errorUpdatingProfile: "Error updating profile",
        errorChangingRole: "Error changing role",
        errorDeletingAccount: "Error deleting account",
        errorUploadingImage: "Error uploading image",
        
        // Form validation messages
        firstNameRequired: "First name is required",
        lastNameRequired: "Last name is required",
        invalidEmail: "Invalid email address"
      },

      // Authentication
      auth: {
        login: "Login",
        register: "Sign Up",
        logout: "Logout",
        signIn: "Sign In",
        signUp: "Sign Up",
        signOut: "Sign Out",
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
        forgotPassword: "Forgot your password?",
        resetPassword: "Reset Password",
        rememberMe: "Remember me",
        createAccount: "Create Account",
        alreadyHaveAccount: "Already have an account?",
        dontHaveAccount: "Don't have an account?",
        accountDeleted: "Account Deleted",
        accountRestricted: "Account Access Restricted",
        authenticationFailed: "Authentication Failed",
        unauthorized: "Unauthorized"
      },

      // Dashboard & Home
      dashboard: {
        welcomeBack: "Welcome back",
        accountStatus: "Account Status",
        emailStatus: "Email Status",
        subscription: "Subscription",
        memberSince: "Member Since",
        active: "Active",
        inactive: "Inactive",
        verified: "Verified",
        pending: "Pending",
        free: "Free",
        quickActions: "Quick Actions",
        recentActivity: "Recent Activity",
        statistics: "Statistics",
        analytics: "Analytics",
        reports: "Reports",
        settings: "Settings",
        accountOverview: "Account Overview",
        upgradeToPremium: "Upgrade to Premium"
      },

      // Profile
      profile: {
        title: "Profile Settings",
        subtitle: "Manage your personal information and account settings",
        tabs: {
          profile: "Profile",
          account: "Account"
        },
        personalInfo: "Personal Information",
        profileImage: {
          changePhoto: "Click on the camera icon to change your profile photo.",
          fileInfo: "JPG and PNG files only, maximum 5MB",
          uploading: "Uploading..."
        },
        form: {
          firstName: "First Name",
          lastName: "Last Name",
          email: "Email",
          bio: "Biography",
          bioPlaceholder: "Tell us about yourself...",
          location: "Location",
          locationPlaceholder: "City, Country",
          website: "Website",
          websitePlaceholder: "https://example.com",
          phone: "Phone",
          phonePlaceholder: "+1 (555) 123-4567",
          saveChanges: "Save Changes",
          saving: "Saving..."
        },
        accountManagement: {
          title: "Account Type Management",
          changeAccountType: "Change Account Type",
          selectAccountType: "Select account type",
          adminRequired: "Admin access required to change account types",
          roles: {
            guest: "Guest",
            user: "User",
            premium: "Premium",
            admin: "Administrator"
          }
        },
        dangerZone: {
          title: "Danger Zone",
          deleteAccount: "Delete Account",
          deleteAccountDescription: "Once deleted, your account cannot be recovered. This action will permanently delete all your data.",
          deleteMyAccount: "Delete My Account",
          confirmDelete: "Are you absolutely sure?",
          confirmDeleteDescription: "This action cannot be undone. This will permanently delete your account and all associated data.",
          subscriptionWarning: "If you have an active subscription, it will be automatically cancelled at the end of the current billing period. No further charges will be made.",
          cancel: "Cancel",
          yesDeleteAccount: "Yes, delete account",
          deleting: "Deleting..."
        }
      },

      // Favorites
      favorites: {
        myFavorites: "My Favorites",
        loadingFavorites: "Loading favorites...",
        errorLoadingFavorites: "Error loading favorites",
        noFavoritesYet: "You don't have favorites yet",
        saveFavoritesDescription: "Save your favorite statistics by clicking the heart ❤️",
        exploreStatistics: "Explore statistics",
        savedStatistics: "saved statistics",
        savedStatistic: "saved statistic",
        returnToDashboard: "Return to Dashboard"
      },

      // Statistics
      statistics: {
        title: "Statistics",
        trending: "Trending",
        latest: "Latest",
        popular: "Popular",
        featured: "Featured",
        categories: "Categories",
        category: "Category",
        politics: "Politics",
        society: "Society",
        economy: "Economy",
        culture: "Culture",
        technology: "Technology",
        entertainment: "Entertainment",
        sports: "Sports",
        science: "Science",
        lifestyle: "Lifestyle",
        unclassified: "Unclassified",
        viewStatistics: "View statistics",
        readMore: "Read more",
        share: "Share",
        favorite: "Favorite",
        unfavorite: "Remove from favorites",
        loadingTrending: "🔄 Loading trending articles...",
        errorLoadingTrending: "Error loading trending",
        noTrendingArticles: "No trending articles",
        trendingDescription: "Most valued articles will appear here",
        featuredDescription: "Mark an article as featured to appear here in large format",
        
        // Statistics List Page
      hero: {
          description: "Discover fascinating insights and revealing data that transform the way we see the world."
        },
        search: {
          placeholder: "Search statistics...",
          button: "Search",
          allCategories: "All categories"
        },
        results: {
          showing: "Showing",
          of: "of",
          statistics: "statistics",
          noResults: "No statistics found",
          tryFilters: "Try adjusting the search filters.",
          noStatistics: "No statistics available at the moment."
        },
        pagination: {
          previous: "Previous",
          next: "Next"
        },
        
        // Image and Content Attribution
        image: {
          designedBy: "Designed by",
          photoBy: "Photo by",
          updated: "Updated"
        }
      },

      // Landing Page
      landing: {
        hero: {
          title: "Discover",
          subtitle: "the non-obvious",
          description: "Discover data you never knew you needed to know.",
          scrollDown: "Scroll down to explore"
        },
        features: {
          title: "How It Works",
          description: "Discover how Statemia transforms invisible data into revealing insights that change the way we understand the world.",
          dataAnalysis: "Unmeasurable Data",
          dataAnalysisDesc: "We convert invisible behaviors and hidden patterns into quantifiable metrics. From daily habits to emerging social trends.",
          realTimeInsights: "Novel Algorithms",
          realTimeInsightsDesc: "Our advanced algorithms identify unexpected correlations and patterns that traditional methods cannot detect.",
          userExperience: "Human Review",
          userExperienceDesc: "Each statistic goes through a validation process by our data experts, ensuring accuracy, context and relevance in every insight."
        },
        trending: {
          title: "Trending",
          description: "The most popular and relevant statistics of the moment",
          viewAll: "View all statistics"
        },
        curioseme: {
          title: "Curioseme",
          description: "Curious and surprising data that will make you think differently",
          exploreCurioseme: "Explore Curioseme"
        },
        authentemia: {
          title: "Authentemia",
          description: "Verified and high-quality content for reliable analysis",
          learnMore: "Learn more about Authentemia"
        },
        news: {
          title: "News",
          description: "The latest news and updates from the world of data",
          readLatestNews: "Read the latest news"
        },
        demo: {
          title: "Demo Video",
          description: "Coming soon: Statemia demonstration video"
        }
      },

      // Footer
      footer: {
        description: "Statemia revolutionizes the way you analyze data. Discover data you never knew you needed to know.",
        categories: "Categories",
        legal: "Legal",
        aboutUs: "About us",
        contact: "Contact",
        legalNotice: "Legal Notice",
        privacyPolicy: "Privacy Policy",
        termsOfService: "Terms of Service",
        cookiePolicy: "Cookie Policy",
        copyright: "© 2025 Statemia. All rights reserved."
      },

      // Admin
      admin: {
        title: "Admin Dashboard",
        users: "Users",
        totalUsers: "Total Users",
        activeUsers: "Active Users",
        premiumUsers: "Premium Users",
        adminUsers: "Admin Users",
        maintenanceMode: "Maintenance Mode",
        systemStatus: "System Status",
        systemSettings: "System Settings",
        userManagement: "User Management",
        analytics: "Analytics",
        logs: "Logs",
        maintenance: "Maintenance",
        status: "Status",
        enabled: "Enabled",
        disabled: "Disabled",
        online: "Online",
        offline: "Offline"
      },

      // Legal
      legal: {
        cookies: {
          essential: "Essential Cookies",
          analytics: "Analytics Cookies",
          preferences: "Preference Cookies",
          functionality: "Functionality Cookies",
          advertising: "Advertising Cookies"
        },
        
        // Cookie Banner
        message: "We use cookies to improve your experience on our website. By continuing to browse, you accept our use of cookies.",
        learn_more: "Learn more",
        accept: "Accept"
      },

      // GDPR Cookie Banner
      gdpr: {
        title: "Cookie Settings",
        subtitle: "Control your privacy and experience",
        message: "We use cookies and similar technologies to improve your experience on Statemia. Some cookies are essential for the site to function, while others help us personalize content and analyze traffic. You can choose which types of cookies to accept.",
        categories: {
          title: "Cookie Types",
          essential: {
            title: "Essential Cookies",
            description: "Necessary for the basic functioning of the website. Cannot be disabled.",
            type: "Required"
          },
          analytics: {
            title: "Analytics Cookies",
            description: "Help us understand how users interact with our website by collecting information anonymously (Google Analytics).",
            type: "Optional"
          },
          preferences: {
            title: "Preference Cookies",
            description: "Remember your choices and settings to personalize your experience.",
            type: "Optional"
          },
          functionality: {
            title: "Functionality Cookies",
            description: "Enable enhanced features like remembering your favorites and display settings.",
            type: "Optional"
          },
          advertising: {
            title: "Advertising Cookies",
            description: "Allow relevant ads via Google AdSense and measure their performance. Without this consent ads are not personalized.",
            type: "Optional"
          }
        },
        customize: "Customize",
        consent: "Consent",
        details: "Details",
        consentTitle: "This website uses cookies",
        consentMessage: "The cookies on this website are used to personalize content and ads, offer social media functions and analyze traffic. In addition, we share information about your use of the website with our social media, advertising and web analytics partners, who may combine it with other information you have provided to them or that they have collected from your use of their services.",
        detailsMessage: "You can customize which types of cookies to accept. Essential cookies are necessary for the website to function.",
        acceptAll: "Allow all",
        rejectAll: "Deny",
        back: "Back",
        savePreferences: "Save Preferences",
        cancel: "Cancel",
        enabled: "Enabled",
        disabled: "Disabled",
        learnMore: "Learn more",
        privacyPolicy: "Privacy Policy",
        lastUpdated: "Last updated: " + new Date().toLocaleDateString()
      },
      disclaimer: "The information on this platform is provided \"as is\". We make no representations",
      contact: {
        email: "alejandro@statemia.com",
        support: "Technical Support"
      },

      // Notifications & Messages
      notifications: {
        success: "Success",
        error: "Error",
        warning: "Warning",
        info: "Information",
        accountAccessRestricted: "Account access restricted",
        accountDeleted: "Account deleted",
        authenticationFailed: "Authentication failed",
        unauthorized: "Unauthorized",
        maintenanceModeUpdated: "Maintenance mode updated successfully",
        failedToUpdateMaintenance: "Failed to update maintenance mode"
      },

      // Social Media
      social: {
        twitter: "Twitter",
        github: "GitHub",
        linkedin: "LinkedIn",
        discord: "Discord",
        followUs: "Follow us",
        shareOn: "Share on"
      },

      // Time & Dates
      time: {
        today: "Today",
        yesterday: "Yesterday",
        thisWeek: "This week",
        thisMonth: "This month",
        thisYear: "This year",
        ago: "ago",
        minutes: "minutes",
        hours: "hours",
        days: "days",
        weeks: "weeks",
        months: "months",
        years: "years"
      },

      // Numbers & Currency
      numbers: {
        thousand: "thousand",
        million: "million",
        billion: "billion",
        trillion: "trillion"
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es', // Default to Spanish
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
